<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          {{ $t('invoiceInfo') }}
        </h1>
      </div>
    </div>
    <invoice-info-list></invoice-info-list>
  </main>
</template>

<script>
import InvoiceInfoList from "./InvoiceInfoList.vue";

export default {
  components: {InvoiceInfoList},
  data: function () {
    return {}
  },
  i18n: {
    messages: {
      en: {
        invoiceInfo: 'Invoice info',
      },
      vi: {
        invoiceInfo: "Thông tin xuất hóa đơn",
      }
    }
  }
}
</script>